import { getAuthState } from './store';
import { refreshAccessToken } from './token';

type AuthMessage = { type: 'login' } | { type: 'logout' };

const CHANNEL = 'orbita-auth';
let channel: BroadcastChannel | null = null;

/** Tells other tabs about a login/logout so they follow (logout everywhere, pick up a new session). */
export function broadcastAuth(message: AuthMessage): void {
  channel?.postMessage(message);
}

export function startCrossTabSync(): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => undefined;
  channel = new BroadcastChannel(CHANNEL);
  channel.onmessage = (event: MessageEvent<AuthMessage>) => {
    const { status } = getAuthState();
    if (event.data.type === 'logout' && status === 'authenticated') getAuthState().clear('other-tab');
    if (event.data.type === 'login' && status === 'anonymous')
      void refreshAccessToken().catch(() => undefined);
  };
  return () => {
    channel?.close();
    channel = null;
  };
}
